'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { useChildSponsorship } from '../../../hooks/useChildSponsorship.ts';
import { ChildBioDetailsHeading } from '../../../molecules/child-bio-details/child-bio-details-heading.tsx';
import { ChildBioInfo } from '../../../molecules/child-bio-details/child-bio-info.tsx';
import { SubmitButton } from '../../../molecules/child-bio-details/child-bio-sponsorship-submit-button.tsx';
import { ChildBioSummary } from '../../../molecules/child-bio-details/child-bio-summary.tsx';
import { ChildBioImage } from '../../../molecules/child-bio-image/child-bio-image.tsx';
import { getNote } from '../../../organisms-cms/child-bio/utils/childNote.tsx';
type HelpMeChooseResult = {
  childDetails: ChildDetails;
  childAvailability: ChildAvailabilityItem;
};
export const HelpMeChooseResult: React.FC<HelpMeChooseResult> = t0 => {
  const $ = _c(26);
  const {
    childDetails,
    childAvailability
  } = t0;
  const {
    globalId
  } = childDetails;
  getNote(childDetails);
  const {
    isSubmitting,
    bioErrors,
    handleSponsorshipSubmit
  } = useChildSponsorship(globalId);
  let t1;
  if ($[0] !== childDetails) {
    t1 = <div className="sm:hidden"><ChildBioDetailsHeading seoLevel={2} details={childDetails} /></div>;
    $[0] = childDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== childAvailability || $[3] !== childDetails) {
    t2 = <ChildBioImage details={childDetails} availability={childAvailability} />;
    $[2] = childAvailability;
    $[3] = childDetails;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="ChildBio__media flex-1 align-start">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  if ($[8] !== childDetails) {
    t4 = <div className="hidden sm:block"><ChildBioDetailsHeading seoLevel={2} details={childDetails} /></div>;
    t5 = <ChildBioSummary className="mb-0 sm:pb-comfy-sm text-sm order-1" details={childDetails} />;
    $[8] = childDetails;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== bioErrors || $[12] !== childDetails || $[13] !== handleSponsorshipSubmit || $[14] !== isSubmitting) {
    t6 = <SubmitButton className="order-2 sm:order-last" bioErrors={bioErrors} details={childDetails} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} />;
    $[11] = bioErrors;
    $[12] = childDetails;
    $[13] = handleSponsorshipSubmit;
    $[14] = isSubmitting;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== childDetails) {
    t7 = <div className="order-3 sm:pb-comfy-xl"><ChildBioInfo details={childDetails} /></div>;
    $[16] = childDetails;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="ChildBio__summary flex flex-col flex-1 gap-comfy-sm sm:gap-0 sm:pt-0">{t4}{t5}{t6}{t7}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t3 || $[24] !== t8) {
    t9 = <div className="HelpMeChooseResult"><div className="ChildBio ChildBio__flex flex flex-col"><div className="ChildBio__content flex flex-col sm:flex-row gap-comfy-sm sm:gap-comfy-xl">{t3}{t8}</div></div></div>;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};